import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import {
  UserService,
  TransferService,
  WalletService,
  CurrenciesService,
  OperationService
} from "@/services";
const exchangeAutoComplete = () =>
  import("@/components/ExchangeAutoComplete/index");
const NumberInput = () => import("@/components/NumberInput/index");
const OtpVerify = () => import("@/components/Shared/OtpVerify/index");
import $thousandMask from "@/mixins/thousandMask";
import $exponent from "@/mixins/exponent";
import { windowOpen } from "echarts/lib/util/format";
export default {
  name: "transfer",
  components: { exchangeAutoComplete, NumberInput, OtpVerify },
  props: [],
  mixins: [$thousandMask, $exponent],
  data() {
    return {
      isMarketActive: true,
      isMobileVerified: true,
      orderAmount: "",
      orderId: "",
      loading: false,
      amount: null,
      showValidation: true,
      userVerification: {},
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
      max: true,
      fromCurrency: {},
      transferFlag: true,
      marketUrl: process.env.VUE_APP_MARKET_BASE_URL,
      checkTermsAndConditionMarket: true,
      channelLabel: [],
      ////////////////////////
      getCurrencies: [],
      getWallets: {},
      getExchanges: {},
      isCurrencyLoaded: false,
      isWalletLoaded: false,
      isExchangeLoaded: false,
      currencies: [],
      selectedCurrency: "",
      availableAmount: 0,
      exponent: 0,
      minWithdraw: null,
      maxWithdraw: null,
      showConfirmDialog: false
    };
  },
  computed: {
    ...mapGetters({
      // getCurrencies: types.currencies.getters.GET_CURRENCIES,
      // getExchanges: types.wallets.getters.GET_EXCHANGE_WALLETS,
      // getWallets: types.operations.getters.GET_WALLET,
      getTransferCurrencies: types.operations.getters.GET_TRANSFER_CURRENCIES
    }),
    setCurrencies() {
      let data = [];
      if (Object.entries(this.getWallets).length > 0) {
        this.getWallets.wallets.forEach(elem => {
          if (elem.is_transfer_to_market_place_active) {
            data.push(elem);
          }
        });
        return data;
      }
    },
    setFromCurrency() {
      let data = {};
      if (Object.entries(this.currencies).length > 0) {
        data = this.currencies.find(elem => {
          if (elem.currency.iso === this.$route.query.from) {
            return elem;
          }
        });
        if (!data) {
          this.$router.push({
            query: { from: this.currencies[0].iso }
          });
        }
        return data;
      }
    },
    fromCurrencyData() {
      if (Object.entries(this.getCurrencies).length > 0) {
        return this.getCurrencies.find(elem => {
          if (elem.iso === this.$route.query.from) {
            return elem;
          }
        });
      }
    },
    // currencyIsoQuery() {
    //   return this.$route.query.from;
    // },
    cryptoExchange() {
      this.showValidation = true;
      // let min,
      //   max,
      //   balance,
      //   iso = "";
      // if (
      //   Object.entries(this.getExchanges).length > 0 &&
      //   Object.entries(this.getWallets).length > 0
      // ) {
      //   this.getWallets.wallets.find(item => {
      //     if (item.currency.iso === this.$route.query.from) {
      //       balance = parseFloat(item.balance_string_format);
      //     }
      //   });
      //   this.getExchanges.data[this.$route.query.from].find(elem => {
      //     if (elem.to === this.$route.query.from) {
      //       min = parseFloat(elem.minimum_amount_to);
      //       max = parseFloat(elem.maximum_amount_to);
      //       iso = elem.to;
      //     }
      //   });
      //   if (this.orderAmount === 0 || this.orderAmount === "") {
      //     this.transferFlag = true;
      //     return "";
      //   } else if (this.orderAmount > balance) {
      //     this.transferFlag = true;
      //     return "موجودی کیف پول شما کافی نیست.";
      //   } else if (this.orderAmount > max) {
      //     this.transferFlag = true;
      //     return `حداکثر مقدار قابل برداشت ${this.$thousandMask(
      //       max
      //     )} ${iso} است.`;
      //   } else if (this.orderAmount < min) {
      //     this.transferFlag = true;
      //     return `حداقل مقدار قابل برداشت ${this.$thousandMask(
      //       min
      //     )} ${iso} است.`;
      //   } else {
      //     this.transferFlag = false;
      //     return "";
      //   }
      // }

      // after refactor
      if (this.minWithdraw && this.maxWithdraw) {
        if (this.orderAmount === 0 || this.orderAmount === "") {
          this.transferFlag = true;
          return "";
        } else if (
          parseFloat(this.orderAmount) > parseFloat(this.availableAmount)
        ) {
          this.transferFlag = true;
          return this.$t("operationsPage.transfer.balanceNotEnought");
        } else if (
          parseFloat(this.orderAmount) > parseFloat(this.maxWithdraw)
        ) {
          this.transferFlag = true;
          return this.$t("operationsPage.transfer.maxTransfer", {
            amount: `${this.$thousandMask(this.maxWithdraw)} ${
              this.selectedCurrency
            }`
          });
        } else if (
          parseFloat(this.orderAmount) < parseFloat(this.minWithdraw)
        ) {
          this.transferFlag = true;
          return this.$t("operationsPage.transfer.minTransfer", {
            amount: `${this.$thousandMask(this.minWithdraw)} ${
              this.selectedCurrency
            }`
          });
        } else {
          this.transferFlag = false;
          return "";
        }
      }
    }
  },
  // watch: {
  //   setFromCurrency: {
  //     immediate: true,
  //     handler(newValue) {
  //       // if (newValue && Object.entries(newValue).length > 0) {
  //       //   this.fromCurrency = newValue;
  //       // }
  //       // this.selectedCurrency = newValue
  //     },
  //   },
  // },
  mounted() {
    this.getUserInformation();
    this.checkAcceptMarketTerms();
    // this.getCurrenciesService();
    // this.getWalletService();
    // this.getExchangeService();
    this.getTransferCurrenciesV2();
  },
  methods: {
    ...mapActions({
      setTransferData: types.transfer.actions.ACTION_TRANSFER_TO_MARKET
    }),
    channelLabelFunc(data) {
      this.channelLabel = data;
    },
    getUserInformation() {
      UserService.getVerifyInfo().then(response => {
        this.userVerification = response.data.data;
        this.isMobileVerified = response.data.data.is_mobile_verified;
      });
    },
    updateFromCurrency(data) {
      this.$router.push({ query: { from: data } });
      WalletService.getWalletDetailsV2(data).then(res => {
        this.availableAmount = res.data.data.balance.available;
        this.selectedCurrency = data;
        this.exponent = res.data.data.exponent;
        this.currencyId = res.data.data.currency_id;
      });
      OperationService.getNetworkV2(this.$route.query.from).then(response => {
        this.minWithdraw =
          response.data.data.limitation_amount?.transfer_to_market?.min;
        this.maxWithdraw =
          response.data.data.limitation_amount?.transfer_to_market?.max;
      });
      this.amount = "";
      this.orderAmount = "";
    },
    orderCryptoTransfer() {
      this.fromCurrency.transferAmount = this.orderAmount;
      this.fromCurrency.iso = this.selectedCurrency;
      this.setTransferData(this.fromCurrency);
      if (this.transferFlag) {
        return;
      }
      this.$router.push({
        name: "transfer-process",
        params: {
          coin: this.fromCurrency.iso
        },
        query: {
          ...this.$route.query,
          currency_id: this.currencyId
        }
      });
    },
    openNewWindowOfMarket() {
      windowOpen(this.marketUrl, "_blank");
      this.$emit("closeDialog", false);
    },
    checkAcceptMarketTerms() {
      TransferService.getUserAgreement()
        .then(response => {
          this.checkTermsAndConditionMarket =
            response.data.data.agreement_status;
        })
        .catch(error => {
          this.isMarketActive = true;
          this.$toast.error(error.data.message);
        });
    },
    getCurrenciesService() {
      CurrenciesService.getCurrencies().then(async response => {
        this.getCurrencies = response.data.data;
        this.isCurrencyLoaded = true;
      });
    },
    getWalletService() {
      WalletService.getWalletV4().then(response => {
        this.getWallets = response.data.data;
        this.isWalletLoaded = true;
      });
    },
    getExchangeService() {
      WalletService.getExchanges().then(response => {
        this.getExchanges = response.data.data;
        this.isExchangeLoaded = true;
      });
    },

    getTransferCurrenciesV2() {
      OperationService.getTransferCurrenciesV2().then(response => {
        this.currencies = response.data.data;
        this.isCurrencyLoaded = true;
        if (!this.$route.query.from) {
          this.selectedCurrency = this.currencies[0].iso;
          this.$router.push({
            query: {
              from: this.currencies[0].iso
            }
          });
        } else {
          this.selectedCurrency = this.$route.query.from;
        }
        this.updateFromCurrency(this.selectedCurrency);
      });
    }
  }
};
